import { useQuery } from '@tanstack/react-query';

export function useCompanyRolesCourseCompanyRolesQuery({
  companyRoleId,
  queryOptions,
}) {
  return useQuery({
    queryKey: ['companyRoles', companyRoleId, 'courseCompanyRoles'],
    queryFn: async () => {
      const response = await axios.get(
        `/company_roles/${companyRoleId}/course_company_roles`,
      );

      return response.data;
    },
    ...queryOptions,
  });
}
